import { createAsyncActions } from '~/utils/store';

export const SHOW = '@@DRAWER_LEADSV2/SHOW';
export const CLOSE = '@@DRAWER_LEADSV2/CLOSE';

export const CREATE = createAsyncActions('@@DRAWER_LEADSV2/CREATE');
export const BATCH = createAsyncActions('@@DRAWER_LEADSV2/BATCH');
export const SAVE = createAsyncActions('@@DRAWER_LEADSV2/SAVE');
export const DELETE = createAsyncActions('@@DRAWER_LEADSV2/DELETE');

export const FETCHQTDD = createAsyncActions('@@LEADSV2/FETCHQTDD');
export const MOVE = createAsyncActions('@@LEADSV2/MOVE');
export const LOAD = createAsyncActions('@@LEADSV2/LOAD');
export const LOAD_MORE_LEADS = createAsyncActions('@@LEADSV2/LOAD_MORE_LEADS');

export const show = (data = null) => ({
    type: SHOW,
    payload: {
        data
    }
});

export const close = () => ({
    type: CLOSE,
    payload: {}
});

export const create = (data) => ({
    type: CREATE.INIT,
    payload: {
        request:{
            method: 'post',
            url:'/leads_v2',
            data,
            showLoading: false
        }
      }
});

export const batch = (data) => ({
    type: BATCH.INIT,
    payload: {
        request:{
            method: 'post',
            url:'/leads_v2/batch',
            data,
            showLoading: false
        }
      }
});

export const update = (id, data) => ({
    type: SAVE.INIT,
    payload: {
        request:{
            method: 'put',
            url:`/leads_v2/${id}`,
            data,
            showLoading: false
        }
    }
});

export const remove = (lead) => ({
    type: DELETE.INIT,
    payload: {
        request:{
            method: 'delete',
            url:`/leads_v2/${lead.id}`
        },
        lead
    }
});

export const loadLeads = (entity_type) => ({
    type: LOAD.INIT,
    payload: {
        request: {
            method: "GET",
            url: "/leads_v2?entity_type=" + entity_type,
        }
    }
});

export const loadMoreLeads = (entity_type, { columnId, currentCount, moreCount }) => ({
    type: LOAD_MORE_LEADS.INIT,
    payload: {
        request: {
            method: "GET",
            url: `/leads_v2/more?stage=${columnId}&current_count=${currentCount}&more_count=${moreCount}&entity_type=${entity_type}`,
            columnId
        },
    },
})

export const fetchQtddByMonth = (entity_type, { date }) => ({
    type: FETCHQTDD.INIT,
    payload: {
        request:{
            method: 'get',
            url:`/leads_v2/qtdd/${date}?entity_type=${entity_type}`
        }
    }
});

export const move = (entity_type, props) => ({
    type: MOVE.INIT,
    payload: {
        request:{
            method: 'put',
            url:`/leads_v2/${props[4]}/move?entity_type=${entity_type}`,
            data: {to: props[3].droppableId}
        },
    },
    props: props
});